import type { components } from '@/generated/internal-api/openapi-types';

export type ExportV1 = components['schemas']['ExportV1'];
export type ExportApiId = components['schemas']['ExportApiId'];
export type ExportType = components['schemas']['ExportType'];
export type StudyReportSubType = components['schemas']['StudyReportSubType'];

export const ExportTypeValue = {
  observation: 'observation',
  audit: 'audit',
  study_report: 'study_report',
  recaging: 'recaging',
  randomization: 'randomization',
  datatable: 'datatable',
  sample: 'sample',
  sampling_plan: 'sampling_plan',
} as const satisfies Record<ExportType, ExportType>;

export const STATUS_LABEL: Record<ExportV1['status'], string> = {
  in_progress: 'In progress',
  completed: 'Completed',
  failed: 'Failed',
};

export const TYPE_LABEL: Record<ExportType, string> = {
  [ExportTypeValue.observation]: 'Observation',
  [ExportTypeValue.audit]: 'Audit log',
  [ExportTypeValue.study_report]: 'Study report',
  [ExportTypeValue.recaging]: 'Recaging report',
  [ExportTypeValue.randomization]: 'Randomization',
  [ExportTypeValue.datatable]: 'Datatable',
  [ExportTypeValue.sample]: 'Samples',
  [ExportTypeValue.sampling_plan]: 'Sampling plan',
};

export const SUB_TYPE_LABEL: Record<StudyReportSubType, string> = {
  study_data: 'Study data',
  groups: 'Groups',
  prism: 'Prism',
  dosing: 'Dosing',
};
